<template lang="pug">
  div
    b-row
      b-col.order-md-2(md="4")
        b-card
          b-dropdown(variant="soft-primary", block, text="Nuevo administrador", v-if="$can('create', 'admin')")
            b-dropdown-item(@click="openCreateAdminModal('organization')", v-if="$can('read', 'org-admin')")
              span Administrador de Organización
              p.mb-0.text-secondary.text-sm.text-wrap Administrador con acceso a tu organización con los mismos privilegios que tú
            b-dropdown-item(@click="openCreateAdminModal('account')" v-if="$can('read', 'account-admin')")
              span Administrador de Cuenta
              p.mb-0.text-secondary.text-sm.text-wrap Administrador con accceso solo a la cuenta que especifiques
            b-dropdown-item(@click="openCreateAdminModal('agent')" v-if="$can('read', 'agent-admin')")
              span Agente
              p.mb-0.text-secondary.text-sm.text-wrap Administrador con accceso solo a la cuenta que especifiques, con privilegios limitados
          hr
          .text-help
            alert-circle-icon.icon-md.mr-1
            span Los administradores y agentes sólo se pueden asociar a cuentas de esta organización.
      b-col(md="8")
        b-card(no-body, style="width:100%;")
          template(slot="header")
            b-form-row
              b-col
                b-form-group.mb-0
                  k-select(v-model="account_filter_id", placeholder="Filtrar por cuenta...", clearable, :load-options="loadOptions", :async="true", :default-options="true", @input="getAccountAdmins")
          b-table.card-table.table-nowrap.mb-0(:items="admins", :fields="fields", responsive, @row-clicked="prevUpdate($event)", show-empty, hover)
            template(v-slot:empty)
              p.text-help.mb-0 No hay admins creados
            template(v-slot:cell(name)="data")
                .d-flex.align-items-center
                  Avatar.mr-2(v-if="data.item.image" :size="'xxs'", :src="data.item.image")
                  b-link.text-dark(@click="prevUpdate(data.item)") {{ data.item.first_name }} {{ data.item.last_name }}

    b-modal(v-model="new_admin_modal", centered, size="lg", title="Crear nuevo admin", cancel-title="Cancelar", ok-title="Crear", ok-variant="primary", @ok="createAdmin", @show="resetModal")
      b-container(fluid)
        Avatar.m-auto.pointer(style="width: fit-content;", :size="'xl'", :src="new_admin.image" v-b-tooltip.hover :title="new_admin.image ? 'Cambiar imagen' : 'Subir imagen'", @click="$refs.input_image.click()")
        p.my-2.text-danger.text-center.text-underline.text-sm.pointer(v-if="new_admin.image", @click="new_admin.image = '';$refs.input_image.value = null;") Quitar imagen
        label Nombre:
        b-form-input(v-model="new_admin.first_name" placeholder="Nombre", trim, :state="new_admin.first_name ? null : (new_admin.validated ? false : null)")
        label.mt-2 Apellido:
        b-form-input(v-model="new_admin.last_name", placeholder="Apellido", trim, :state="new_admin.last_name ? null : (new_admin.validated ? false : null)")
        b-form-group
          template(slot="description")
            v-icon.mr-1(name="brands/facebook-messenger", scale=".8", style="color:#4267b2;")
            span PersonaAPI: Cuando contesta a una conversación de Messenger se mostrará este nombre como autor del mensaje.
          label.mt-2 Nombre para mostrar:
          b-form-input(v-model="new_admin.display_name", placeholder="Nombre para mostrar", trim)
        b-form-group(label="Puede atender casos")
          b-form-checkbox(switch, v-model="new_admin.can_attend_cases") {{new_admin.can_attend_cases ? 'Sí' : 'No'}}
        label.mt-2 Email:
        b-form-input(v-model="new_admin.email", type="email", placeholder="Email", trim, :state="emailValid(new_admin.email) ? null : (new_admin.validated ? false : null)")
        label.mt-2 Password:
        b-form-input(v-model="new_admin.password", placeholder="Contraseña", trim, :state="new_admin.password ? null : (new_admin.validated ? false : null)")
        div.mt-2(v-if="admin_type == 'account'")
          label Rol:
          b-form-select(v-model="new_admin.role_id", :state="new_admin.role_id ? null : (new_admin.validated ? false : null)")
            option(value="", disabled) -- Seleccionar rol --
            option(:value="null") No asignar rol
            option(v-for="role in parsedRoles", :key="role.role_id", :value="role.role_id") {{role.name}}
        div.mt-2(v-if="admin_type != 'organization'")
          label Asignar cuenta:
          b-form-group
            k-select(v-model="admin_account_id", placeholder="Seleccionar cuenta...", :load-options="loadOptions", :async="true", :default-options="true")
            b-form-invalid-feedback(:state="admin_account_id ? null : (new_admin.validated ? false : null)") Selecciona una cuenta
    b-modal(v-model="update_admin_modal", centered, size="lg", title="Actualizar admin", cancel-title="Cancelar", ok-title="Actualizar", ok-variant="primary", @ok="updateAdmin")
      b-container(fluid)
        b-alert(variant="success", :show="admin_just_created") ¡Creado con éxito! Puedes asociarlo a cuentas de tu organización.
        Avatar.m-auto.pointer(style="width: fit-content;", :size="'xl'", :src="update_admin.image || ''" v-b-tooltip.hover :title="update_admin.image ? 'Cambiar imagen' : 'Subir imagen'", @click="$refs.input_image_update.click()")
        p.my-2.text-danger.text-center.text-underline.text-sm.pointer(v-if="update_admin.image", @click="update_admin.image = '';$refs.input_image_update.value = null;") Quitar imagen
        label Nombre del admin:
        b-form-input(v-model="update_admin.first_name" placeholder="Nombre", trim, :state="update_admin.first_name ? null : (update_admin.validated ? false : null)")
        label.mt-2 Apellido:
        b-form-input(v-model="update_admin.last_name", placeholder="Apellido", trim, :state="update_admin.last_name ? null : (update_admin.validated ? false : null)")
        b-form-group
          template(slot="description")
            v-icon.mr-1(name="brands/facebook-messenger", scale=".8", style="color:#4267b2;")
            span PersonaAPI: Cuando contesta a una conversación de Messenger se mostrará este nombre como autor del mensaje.
          label.mt-2 Nombre para mostrar:
          b-form-input(v-model="update_admin.display_name", placeholder="Nombre para mostrar", trim)
        b-form-group(label="Puede atender casos")
          b-form-checkbox(switch, v-model="update_admin.can_attend_cases") {{update_admin.can_attend_cases ? 'Sí' : 'No'}}
        label.mt-2 Email:
        b-form-input(v-model="update_admin.email", placeholder="Email", trim, :state="emailValid(update_admin.email) ? null : (update_admin.validated ? false : null)")
        label.mt-2 Rol:
        b-form-select(:value="update_admin.role_id == null || parsedRoles.find(r => r.role_id == update_admin.role_id) ? update_admin.role_id : 'other'", @change="update_admin.role_id = $event", :state="update_admin.role_id ? null : (update_admin.validated ? false : null)")
          option(value="", disabled) -- Seleccionar rol --
          option(disabled, value="other") Otro rol
          option(:value="null") No asignar rol
          option(v-for="role in parsedRoles", :key="role.role_id", :value="role.role_id") {{role.name}}
        div
          label.mt-3.pointer.text-primary(aria-controls="show_accounts" @click="show_accounts = !show_accounts")
            span.mr-1 Cuentas asociadas
            chevron-down-icon.icon-sm
        b-collapse(:id="'show_accounts'", v-model="show_accounts", accordion="accounts-accordion")
          b-card.mb-0(no-body)
            template(slot="header")
              b-row
                b-col(cols="auto")
                  b-form-select(v-model="account_id_selected", @change="associateAccount")
                    option(:value="null" disabled) Asociar cuenta...
                    option(v-for="account in accounts", :key="account.account_id" :value="account.account_id") {{account.name}}
            b-table.card-table.table-nowrap.mb-0(:items="update_admin.accounts", :fields="account_fields", responsive, show-empty, style="max-height:250px")
              template(v-slot:empty)
                p.my-4.text-help.text-center No tiene cuentas asociadas
              template(v-slot:cell(name)="data")
                .d-flex.align-items-center
                  Avatar.mr-3(v-if="data.item.image_dashboard" :size="'xxs'", :src="data.item.image_dashboard")
                  span {{ data.item.name }}
              template(v-slot:cell(actions)="data")
                trash-2-icon.icon-md.hover-danger.pointer(v-b-tooltip.hover="'Remover cuenta'", @click="removeAccount(data.item.account_id)")
        div
          label.mt-2.pointer.text-primary(aria-controls="change_pass", @click="show_change_pass = !show_change_pass")
            span.mr-1 Cambiar contraseña
            chevron-down-icon.icon-sm
        b-collapse(:id="'change_pass'", v-model="show_change_pass", accordion="pass-accordion")
          b-form-group(description="Deja en blanco para omitir cambios", label="Nueva contraseña")
            b-form-input(v-model="update_admin.password", placeholder="Contraseña", trim)
        b-card.bg-light.text-center.text-sm.mb-0.mt-4(v-if="$can('delete', 'admin')")
          alert-triangle-icon.icon-sm.mr-2
          span Eliminar administrador no se puede deshacer.
          p.mb-0.mt-2
            b-link.text-danger(@click="deleteAdmin(update_admin)") Eliminar administrador
    input(type="file", accept="image/*", style="display:none;", ref="input_image", @change="imageSelected($event)")
    input(type="file", accept="image/*", style="display:none;", ref="input_image_update", @change="imageSelected($event, 'update')")
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import Avatar from '../../components/Avatar.vue'
import { UploadFile } from '../../helpers/upload-file'
import Select from '@/components/Select.vue'
import {ASYNC_SEARCH} from "@riophae/vue-treeselect";
import _debounce from 'lodash.debounce'
import Validators from '@/helpers/data_validators';
const roleController = createNamespacedHelpers('role')
const helpersController = createNamespacedHelpers('helpers')
const organizationController = createNamespacedHelpers('organization')


export default {
  mixins: [Validators.Methods],
  data () {
    return {
      admins: [],
      fields: [
        {
          key: 'admin_id',
          label: 'ID'
        },
        {
          key: 'name',
          label: 'Nombre'
        },
        {
          key: 'email',
          label: 'Correo'
        },
      ],
      new_admin_modal: false,
      new_admin: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        role_id: 'null',
        image: '',
        validated: false,
        display_name: '',
        can_attend_cases: true
      },
      update_admin_modal: false,
      update_admin: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        role_id: 'null',
        image: '',
        admin_id: '',
        validated: false,
        accounts: [],
        display_name: '',
        can_attend_cases: true
      },
      show_change_pass: false,
      show_accounts: false,
      image_file: null,
      account_id_selected: null,
      account_fields: [
        {
          key: 'account_id',
          label: 'ID'
        },
        {
          key: 'name',
          label: 'Nombre'
        },
        {
          key: 'actions',
          label: 'Acciones'
        }
      ],
      admin_just_created: false,
      account_filter_id: null,
      admin_type: '',
      admin_account_id: null,
    }
  },
  computed: {
    ...roleController.mapState({
      roles: state => state.roles
    }),
    ...organizationController.mapState({
      accounts: state => state.accounts
    }),
    parsedAdmins () {
      return this.admins.map(admin => {
        admin.password = ''
        return admin
      })
    },
    parsedRoles () {            
      return this.roles.filter(r => {
        return (new RegExp("^socialkit")).test(r.type)
      })
    },
  },
  methods: {
    ...mapActions(['organization/admins', 'organization/accounts', 'account/admins', 'role/all', 'admin/create', 'admin/update', 'admin/destroy', 'admin/accounts', 'admin/associateAccount', 'admin/removeAccount', 'helpers/upload_file']),
    getAdminsCreated (callback) {
      let self = this

      this['organization/admins']({
        organization_id: self.$route.params.organization_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.admins = res.resource
            if (callback) callback()
          }
        }
      })
    },
    getRoles () {
      let self = this

      this['role/all']({
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getAccounts () {
      let self = this

      this['organization/accounts']({
        organization_id: self.$route.params.organization_id,
        admin_id: self.getCurrentUser().admin_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    lastLoginHTML (data) {
      return `<b>Última conexión:</b><br> ${data.item.last_login ? this.$moment(data.item.last_login).format('LLL') : '-'}`
    },
    async createAdmin (bvModalEvt) {
      if (!this.$can('create', 'admin')) return
      let omit = ['validated', 'image', 'display_name', 'role_id', 'can_attend_cases']
      for(let key in this.new_admin) {
        if(omit.indexOf(key) == -1 && this.new_admin[key] == '') {
          bvModalEvt.preventDefault()
          this.new_admin.validated = true
          return
        }
      }
      if(!this.emailValid(this.new_admin.email)) {
        bvModalEvt.preventDefault()
        this.new_admin.validated = true
        return
      }

      let body = {
        account_id: this.$route.params.account_id,
        organization_id_creator: this.$route.params.organization_id
      }

      switch (this.admin_type) {
        case 'organization':
          body.organization_id = this.$route.params.organization_id
          this.new_admin.role_id = this.getCurrentUser().role_id
          break
        case 'account':
          if(this.new_admin.role_id == '' || !this.admin_account_id) {
            bvModalEvt.preventDefault()
            this.new_admin.validated = true
            return
          }
          body.account_id = this.admin_account_id
          break
        case 'agent':
          if(!this.admin_account_id) {
            bvModalEvt.preventDefault()
            this.new_admin.validated = true
            return
          }
          body.account_id = this.admin_account_id
          let role = this.roles.find(r => r.type == 'konverza-agent')
          this.new_admin.role_id = role ? role.role_id : null
          break
      }

      if (this.image_file) {
        try {
          let res = await UploadFile.call(this, this.image_file)
          this.new_admin.image = res
        } catch (e) {
          this.new_admin.image = ''
          this.$message.error(e.message)
        }
      }

      var self = this
      this['admin/create']({
        ...body,
        ...self.new_admin,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Admin creado con éxito')
            self.getAdminsCreated(() => {
              let createdAdmin = self.admins.find(a => a.admin_id == res.resource.admin_id)
              if (createdAdmin) self.prevUpdate(createdAdmin, true)
            })
          }
        }
      })
    },
    resetModal () {
      this.clearObject(this.new_admin, {boolean:true})
      this.$refs.input_image.value = ''
      this.image_file = null
      this.new_admin.role_id = ''
      this.admin_account_id = null
    },
    prevUpdate(admin, justCreated) {
      if (!this.$can('update', 'admin')) return
      this.admin_just_created = justCreated == true;
      this.clearObject(this.update_admin)
      this.update_admin = Object.assign(this.update_admin, admin)
      this.getAdminAccounts()
      this.show_change_pass = false
      this.show_accounts = false
      this.update_admin_modal = !this.update_admin_modal
      this.$refs.input_image_update.value = ''
      this.image_file = null
    },
    async updateAdmin (bvModalEvt) {
      if (!this.$can('update', 'admin')) return
      let omit = ['validated', 'password', 'image', 'accounts', 'display_name']
      for(let key in this.update_admin) {
        if(omit.indexOf(key) == -1 && this.update_admin[key] == '') {
          bvModalEvt.preventDefault()
          this.update_admin.validated = true
          return
        }
      }

      if(!this.emailValid(this.update_admin.email)) {
        bvModalEvt.preventDefault()
        this.update_admin.validated = true
        return
      }

      if (this.image_file) {
        try {
          let res = await UploadFile.call(this, this.image_file)
          this.update_admin.image = res
        } catch (e) {
          this.update_admin.image = ''
          this.$message.error(e.message)
        }
      }

      let admin = JSON.parse(JSON.stringify(this.update_admin))
      if (!admin.password)
        delete admin.password

      let self = this
      this['admin/update']({
        account_id: self.$route.params.account_id,
        ...admin,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Admin actualizado con éxito')
            self.getAdminsCreated()
            self.clearObject(self.update_admin)
          }
        }
      })
    },
    async deleteAdmin (data) {
      if (!this.$can('delete', 'admin')) return
      try {
        let response = await this.$bvModal.msgBoxConfirm(`¿Deseas eliminar este admin? No se puede deshacer.`, {
          title: 'Eliminar admin',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar'
        })

        if(response) {
          let self = this
          this['admin/destroy']({
            account_id: self.$route.params.account_id,
            ...data,
            callback: res => {
              if (res.error) {
                self.$message.error(res.error)
              } else {
                self.$message.success('Admin eliminado con éxito')
                self.getAdminsCreated()
                if (self.update_admin_modal) {
                  self.update_admin_modal = false
                  self.clearObject(self.update_admin)
                }
              }
            }
          })
        }
      } catch (e) {
        console.error(e.message);
      }
    },
    async imageSelected (event, type) {
      let files = event.target.files

      if(files.length) {
        let file = files[0]
        try {
          if (type == 'update') {
            this.update_admin.image = URL.createObjectURL(file)
            this.image_file = file
          } else {
            this.new_admin.image = URL.createObjectURL(file)
            this.image_file = file
          }
        } catch (e) {
          this.$message.warning('No logramos crear la vista previa de la imagen, por favor comprueba tu conexión a internet')
        }
      }
    },
    getAdminAccounts () {
      let self = this

      this['admin/accounts']({
        admin_id: self.update_admin.admin_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.update_admin.accounts = res.resource.slice()
          }
        }
      })
    },
    associateAccount () {
      var self = this

      let exist = this.update_admin.accounts.find(a => {
        return a.account_id == self.account_id_selected
      })

      if(exist){
        this.$message.warning('La cuenta ya se encuentra asociada')
      } else {
        this['admin/associateAccount']({
          admin_id: self.update_admin.admin_id,
          account_id : self.account_id_selected,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
            } else {
              self.$message.success('Cuenta asociada con éxito')
              self.getAdminAccounts()
            }
          }
        })
      }
      self.account_id_selected = null
    },
    async removeAccount (account_id) {
      let self = this

      this['admin/removeAccount']({
        admin_id: self.update_admin.admin_id,
        account_id: account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Cuenta removida con éxito')
            self.getAdminAccounts()
          }
        }
      })

    },
    async loadOptions ({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        callback(null, await this.searchAccounts(searchQuery))
      }
    },
    searchAccounts (searchQuery) {
      let self = this

      return new Promise ((resolve, reject) => {

        let params = {
          ...self.paginationParamsObject,
        }

        if (searchQuery) params.name = searchQuery

        this['organization/accounts']({
          organization_id: self.$route.params.organization_id,
          params,
          callback: res => {
            if (res.error) {
              self.$message.error(res.error)
              resolve([])
            } else {
              resolve(res.resource.map(a => {
                return {
                  label: a.name,
                  id: a.account_id
                }
              }))
            }
          }
        })
      })
    },
    getAccountAdmins () {
      if(!this.account_filter_id) {
        this.getAdminsCreated()
        return
      }

      let self = this
      this['account/admins']({
        account_id: self.account_filter_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.admins = res.resource
          }
        }
      })
    },
    openCreateAdminModal (type) {
      this.admin_type = type
      this.new_admin_modal = true
    }
  },
  mounted () {
    this.getAdminsCreated()
    this.getRoles()
    this.getAccounts()
  },
  components: {
    Avatar,
    'k-select': Select,
  }
}
</script>

<style lang="css" scoped>
</style>
